import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Instagram } from "lucide-react";
import logo from "../assets/logo.png";

export default function Footer() {
  return (
    <footer className="section-dark text-slate-300">
      <div className="max-w-7xl mx-auto px-5 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5 mb-4">
            <span className="grid place-items-center w-10 h-10 rounded-xl bg-white overflow-hidden">
              <img src={logo} alt="Flycher Travels" className="w-full h-full object-contain p-0.5" />
            </span>
            <span className="font-display font-bold text-lg text-white">Flycher Travels</span>
          </div>
          <p className="text-sm text-slate-400 max-w-sm leading-relaxed">
            Hand-picked group tours, crafted itineraries, and honest pricing. Plan less, live more.
          </p>
          <div className="flex gap-3 mt-5">
            <a href="https://instagram.com/flychertravels" target="_blank" rel="noopener noreferrer" aria-label="Instagram @flychertravels" className="grid place-items-center w-9 h-9 rounded-lg bg-white/10 hover:bg-coral-600 transition-colors"><Instagram className="w-4 h-4" /></a>
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/tours" className="hover:text-white">All Tours</Link></li>
            <li><Link to="/gallery" className="hover:text-white">Gallery</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/login" className="hover:text-white">Log in</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-amber-400" /> <a href="mailto:flychertravels@gmail.com" className="hover:text-white">flychertravels@gmail.com</a></li>
            <li className="flex items-center gap-2"><Instagram className="w-4 h-4 text-amber-400" /> <a href="https://instagram.com/flychertravels" target="_blank" rel="noopener noreferrer" className="hover:text-white">@flychertravels</a></li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-amber-400 mt-0.5" /> New Delhi, India</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 py-5 text-xs text-slate-500 flex flex-col md:flex-row items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} Flycher Travels. All rights reserved.</span>
          <span>Curated Getaways • Honest Pricing • Effortless Planning</span>
        </div>
      </div>
    </footer>
  );
}
